import { register, getPrefix, roundOneDigit } from '../../../Utils'

const MiBaCalculator = el => {
  const prefix = getPrefix(el)

  const initPageSlider = () => {
    let Splide = window.Splide
    const sliderContainer = el.querySelector(`.${prefix}splide-wrapper`)
    const forwardButtons = el.querySelectorAll(`.${prefix}page-action-forward`)
    const backButtons = el.querySelectorAll(`.${prefix}page-action-back`)

    const pageSlider = new Splide(sliderContainer, {
      perMove: 1,
      speed: 800,
      waitForTransition: false,
      arrows: false,
      drag: false,
      classes: {
        pagination: `splide__pagination calculator-pagination position-absolute`,
        page: `splide__pagination__page calculator-page-bubble cursor-pointer`
      }
    })

    pageSlider.mount()

    forwardButtons.forEach(button => button.addEventListener('click', () => { pageSlider.go('>') }))
    backButtons.forEach(button => button.addEventListener('click', () => { pageSlider.go('<') }))
  }

  const initCalculator = () => {
    // input fields
    const inputX = el.querySelector('#InputX')
    const inputN = el.querySelector('#InputN')
    const buttons = {
      x: el.querySelector(`.${prefix}forward-x`),
      n: el.querySelector(`.${prefix}forward-n`)
    }

    // stored input values
    // x: extractions per month
    // n: cost per chair per hour
    const inputValues = {
      x: 0,
      n: 0
    }

    // output fields
    const OutputDeltaY = el.querySelector('#OutputDeltaY')
    const OutputDeltaZ = el.querySelector('#OutputDeltaZ')
    const OutputDeltaR = el.querySelector('#OutputDeltaR')
    const OutputDeltaP = el.querySelector('#OutputDeltaP')

    const changeInputValue = (e, type, min, max) => {
      const inputValue = +e.currentTarget.value
      buttons[type].classList.toggle(`${prefix}is--deactivated`, inputValue === 0)

      if (inputValue < min || inputValue > max) {
        // ToDo: Show a small reminder of minMax values
        e.preventDefault()
        e.currentTarget.value = inputValues[type]
        return
      }

      inputValues[type] = inputValue
      calculateAndOutput()
    }

    // listen to changes in input fields
    inputX.addEventListener('input', e => changeInputValue(e, 'x', 0, 99))
    inputN.addEventListener('input', e => changeInputValue(e, 'n', 0, 999))

    const calculateAndOutput = () => {
      const resultY = inputValues.x * 5 / 8.5
      // outputY.innerText = roundOneDigit(resultY)
      const resultZ = inputValues.x * 9 / 8.5
      // outputZ.innerText = roundOneDigit(resultZ)
      const resultYY = inputValues.x * 3 / 8.5
      // outputYY.innerText = roundOneDigit(resultYY)
      const resultZZ = inputValues.x * 5 / 8.5
      // outputZZ.innerText = roundOneDigit(resultZZ)
      const resultR = inputValues.x * inputValues.n * 5
      // outputR.innerText = roundOneDigit(resultR)
      const resultP = inputValues.x * inputValues.n * 9
      // outputP.innerText = roundOneDigit(resultP)
      const resultRR = inputValues.x * inputValues.n * 3
      // outputRR.innerText = roundOneDigit(resultRR)
      const resultPP = inputValues.x * inputValues.n * 5
      // outputPP.innerText = roundOneDigit(resultPP)
      OutputDeltaY.innerText = roundOneDigit(resultY - resultYY)
      OutputDeltaZ.innerText = roundOneDigit(resultZ - resultZZ)
      OutputDeltaR.innerText = roundOneDigit(resultR - resultRR)
      OutputDeltaP.innerText = roundOneDigit(resultP - resultPP)
    }
  }

  initPageSlider()
  initCalculator()
}

register('MiBaCalculator', MiBaCalculator)
